(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nexgi-home-video-slider"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super();

    const initSlider = () => {
      this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions());
  
      this.slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing');
        this.onSlideChange();
      });
  
      this.slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing');
      });
    };
  
    if (!window.Swiper) {
      if (!document.querySelector('#swiper-script')) {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.id = 'swiper-script';
        script.onload = initSlider; // Call once loaded
        document.head.appendChild(script);
      } else {
        // Wait until script loads if already added
        document.querySelector('#swiper-script').addEventListener('load', initSlider);
      }
    } else {
      initSlider(); // Swiper is already available
    }
  
    // Add video listeners
    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video');
        this.onVideoPlay(video);
      });
    });
  
    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video);
      });
    });
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }

}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();
})();
